(() => {
  if (window.kallesStampUploadInstalled) return;
  window.kallesStampUploadInstalled = true;
  const selector = 'form[data-stamp-form="true"]';
  function prepare(form) {
    const display = form.querySelector('[data-stamp-filename]');
    const chosen = form.querySelector('input[type="file"]')?.files?.[0];
    if (display) display.textContent = chosen ? chosen.name : 'No file chosen';
    form.enctype = 'multipart/form-data';
    form.removeAttribute('novalidate');
    const file = form.querySelector('input[type="file"]');
    if (file) { file.required = false; file.accept = '.png,.jpg,.jpeg,.pdf'; }
  }
  function validate(form, required = false) {
    prepare(form);
    const input = form.querySelector('input[type="file"]');
    const file = input?.files?.[0];
    let message = '';
    if (!input) message = 'Artwork upload is unavailable. Please contact us before ordering.';
    else if (!file && required) message = 'Please upload your logo before checkout, or add the stamp to your cart and upload it there.';
    else if (file && !/\.(png|jpe?g|pdf)$/i.test(file.name)) message = 'Please use a PNG, JPG or PDF file.';
    else if (file && !file.size) message = 'This file is empty. Please choose another file.';
    else if (file && file.size > 10 * 1024 * 1024) message = 'Please use a file no larger than 10 MB.';
    input?.setCustomValidity(message);
    const error = form.querySelector('[data-stamp-error]');
    if (error) { error.textContent = message; error.hidden = !message; }
    return !message && form.reportValidity();
  }
  function submit(form, button) {
    const addButton = form.querySelector('[data-atc-form]');
    if (addButton?.disabled || addButton?.getAttribute('aria-disabled') === 'true') return;
    if (button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
    if (!validate(form, button?.hasAttribute('data-stamp-checkout'))) { form.querySelector('input[type="file"]')?.reportValidity(); return; }
    const variant = form.querySelector('[name="id"]');
    if (!variant?.value || variant.disabled || variant.value === 'nathan') return;
    const destination = form.querySelector('[name="return_to"]');
    if (destination) destination.value = destination.dataset.stampCartUrl;
    HTMLFormElement.prototype.submit.call(form);
  }
  // Capture before Kalles' delegated AJAX click handler, which otherwise sends this form too.
  window.addEventListener('click', event => {
    const button = event.target.closest?.('[data-atc-form], [data-stamp-checkout]');
    const form = button?.closest(selector);
    if (!form) return;
    event.preventDefault(); event.stopImmediatePropagation();
    submit(form, button);
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.(selector)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    submit(form, event.submitter || form.querySelector('[data-atc-form]'));
  }, true);
  window.addEventListener('change', event => {
    if (event.target.matches?.(selector + ' input[type="file"]')) validate(event.target.form);
  }, true);
  function init() { document.querySelectorAll(selector).forEach(prepare); }
  init(); document.addEventListener('shopify:section:load', init);
})();
